'use client'

import Button from '@components/common/Button'
import Typography from '@components/common/Typography'
import CommerceCard from '@components/features/CommerceCard'

import Store from '@svg/store.svg'
import Lock from '@svg/lock.svg'
import Mobile from '@svg/mobile.svg'
import Package from '@svg/package.svg'

import Bolt from '@svg/bolt.svg'
import Shield from '@svg/shield.svg'
import CircularCheck from '@svg/circularCheck.svg'

import Check from '@svg/check.svg'
import Dot from '@components/common/Dot'
import Navigation from '@components/Navigation'
import DemoVideoModal from '@components/DemoVideoModal'

export default function Home() {
  const commerceList = [
    {
      icon: <Store />,
      title: 'Storefronts & Payment Links',
      subtitle: 'Create online stores, invoices, QR codes, and payment links in minutes.',
    },
    {
      icon: <Lock />,
      title: 'Unified Closed-Loop Tokenized Payments',
      subtitle: 'Instant settlement inside a secure, closed-loop payment ecosystem powered by xPayz.',
    },
    {
      icon: <Mobile />,
      title: 'Instant Client Apps (No Build Required)',
      subtitle:
        'Clients download an app instantly and receive real-time notifications—no development, no app store approvals.',
    },
    {
      icon: <Package />,
      title: 'Optional Fulfillment',
      subtitle: 'Connect to fulfillment and logistics services without platform lock-in.',
    },
  ]

  const tokenizedPayments = [
    {
      icon: <Bolt />,
      title: 'Instant Settlement',
      list: ['Transactions settle in seconds', 'Funds available instantly', 'No delayed settlement'],
    },
    {
      icon: <Shield />,
      title: 'Secure & Transparent',
      list: ['Immutable ledger records', 'No chargebacks', 'Fully auditable transactions'],
    },
  ]

  const howPaymentsWork = [
    'Payments are issued and settled inside a closed-loop environment',
    'Every transaction is recorded on a secure, immutable ledger',
    'Funds are available instantly, without chargebacks or delayed settlement',
    'Movements are identity-bound and fully auditable',
  ]
  return (
    <div className="relative flex flex-col ">
      {/* top with navigation */}
      <div className="bg-[linear-gradient(135deg,#000000,#1A0000,#2D0A0A)]">
        <Navigation fromHome />
        {/* top */}
        <div className="relative flex flex-col gap-20 items-center pb-32 sm:pb-42 md:pb-55 lg:pb-67 px-6 sm:px-8 md:px-10 lg:px-12 pt-24!">
          <div className="flex flex-col gap-20">
            <div className="flex flex-col gap-7 items-center justify-center text-center ">
              <Typography size="xxl" className="max-w-225">
                Everything you need to sell, get paid, and fulfill orders.
              </Typography>
              <Typography size="md2" className="text-white! max-w-150">
                xPayzMarket is a merchant platform that combines storefronts, payment links, and optional fulfillment
                into one easy-to-use system.
              </Typography>
            </div>
            <div className="flex flex-col gap-9 items-center justify-center text-center">
              <div className="flex flex-col md:flex-row gap-4 items-center justify-center text-center">
                <Button variant="primary" className="">
                  Start free for 3 months
                </Button>
                <DemoVideoModal videoSrc="https://devlance.ams3.cdn.digitaloceanspaces.com/demo/demo.mp4" />
              </div>
              <Typography size="md2" className="text-white!">
                No credit card required.
              </Typography>
            </div>
          </div>
          <div className="absolute bottom-0 left-0 w-full h-32 sm:h-42 md:h-55 lg:h-67 bg-linear-to-t from-white to-white/0 z-50 pointer-events-none"></div>
        </div>
      </div>

      {/* What xPayzMarket Is */}
      <div className="flex flex-col gap-7 bg-[#F9FAFB] py-28 px-12 items-center justify-center text-center ">
        <Typography size="lg2"> What xPayzMarket Is</Typography>
        <Typography size="md2" className="max-w-200">
          xPayzMarket allows businesses to create storefronts, generate payment links, receive payments through the
          Xpayz payment gateway, and optionally fulfill orders Global duty free zones
        </Typography>
        <Typography size="md2" className="max-w-175">
          Designed for merchants who want a structured way to sell and get paid without building custom infrastructure.
        </Typography>
      </div>

      {/* One system for modern commerce */}
      <div className="flex flex-col gap-12 md:gap-16 lg:gap-20 p-7 md:px-12 items-center justify-center max-w-7xl mx-auto">
        <Typography size="lg2" className="text-center">
          One system for modern commerce
        </Typography>
        <div className="grid grid-cols-1 sm:grid-cols-2 gap-x-8 gap-y-12 md:gap-y-20">
          {commerceList.map((item, index) => (
            <CommerceCard key={index} {...item} />
          ))}
        </div>
      </div>

      {/* Tokenized Payments, Built for Real Commerce */}
      <div className="flex flex-col gap-12 md:gap-16 lg:gap-20 p-7 py-12 md:p-12 items-center justify-center max-w-7xl mx-auto">
        <Typography size="lg2" className="text-center max-w-87.5">
          Tokenized Payments, Built for Real Commerce
        </Typography>
        <Typography size="md2" className="max-w-200">
          xPayzMarket operates on a unified, closed-loop tokenized payment system designed for speed, transparency, and
          operational efficiency. Payments settle in seconds inside the xPayz ecosystem, without relying on multiple
          banks or card networks.
        </Typography>
        <div className="grid grid-cols-1 sm:grid-cols-2 gap-x-8 gap-y-20">
          {tokenizedPayments.map((item, index) => (
            <div className="flex flex-col gap-3 p-6 border-2 border-gray-200 rounded-xl default-shadow" key={index}>
              <div className="flex flex-col gap-4 ">
                <div className="bg-error-stroke text-primary-400 rounded-2xl p-1.5 flex items-center justify-center w-12 h-12">
                  {item.icon}
                </div>
                <Typography size="lg" className="font-bold! text-black!">
                  {item.title}
                </Typography>
              </div>
              <div className="flex flex-col gap-2">
                {item.list.map((list, index) => (
                  <Typography size="md2" key={index} className="flex gap-2 items-center">
                    <CircularCheck className="text-primary-400" />
                    {list}
                  </Typography>
                ))}
              </div>
            </div>
          ))}
        </div>
      </div>

      {/* How Tokenized Payments Work */}
      <div className="flex flex-col gap-12 md:gap-16 lg:gap-20 p-7 py-12 md:p-12 items-center justify-center max-w-7xl mx-auto">
        <Typography size="lg2" className="text-center ">
          How Tokenized Payments Work
        </Typography>

        <div className="flex flex-col gap-6">
          {howPaymentsWork.map((item, index) => (
            <div key={index} className="flex gap-4 p-6 rounded-2xl default-shadow">
              <div className="bg-primary-400 text-on-primary rounded-full p-1.5 flex items-center justify-center w-8 h-8">
                <Check className="w-5 h-5" />
              </div>
              <Typography size="md2">{item}</Typography>
            </div>
          ))}
        </div>
      </div>

      <div className="flex flex-col gap-20 p-7 py-12 md:p-12 items-center justify-center max-w-7xl mx-auto">
        {/* BRXP & USXP */}
        <div className="grid grid-cols-1 sm:grid-cols-2 gap-x-8 gap-y-10">
          {/* BRXP */}
          <div className="flex flex-col gap-12 p-7 md:p-12 rounded-2xl border-2 border-gray-200 default-shadow">
            <div className="bg-primary-400 p-1 px-3 rounded-full">
              <Typography size="md2" className="text-white">
                BRXP
              </Typography>
            </div>

            <Typography size="md2" className="">
              Brazilian-real-denominated ledger token for local payments and collections in Brazil.
            </Typography>
          </div>

          {/* USXP */}
          <div className="flex flex-col gap-12 p-7 md:p-12 rounded-2xl border-2 border-gray-200 default-shadow">
            <div className="bg-secondary-400 p-1 px-3 rounded-full">
              <Typography size="md2" className="text-white">
                USXP
              </Typography>
            </div>

            <Typography size="md2" className="">
              U.S.-dollar-denominated ledger token for USD settlement, treasury management, and international trade.
            </Typography>
          </div>
        </div>

        {/* xPayz ecosystem */}
        <ul className="flex flex-col gap-3 rounded-2xl w-full bg-gray-50 p-8">
          <li className="flex items-center gap-3">
            <Dot className="text-primary-400" />{' '}
            <Typography size="md2">Used only within the xPayz ecosystem</Typography>
          </li>
          <li className="flex items-center gap-3">
            <Dot className="text-primary-400" />
            <Typography size="md2">Backed by underlying fiat movement through regulated partners</Typography>
          </li>
          <li className="flex items-center gap-3">
            <Dot className="text-primary-400" />
            <Typography size="md2">Designed for payments and settlement, not speculation</Typography>
          </li>
        </ul>
      </div>
    </div>
  )
}
